export default __webpack_public_path__ + "3287e28ce0178e152d1f93cedbc84cbb.svg";